// extracted by mini-css-extract-plugin
module.exports = {"buttonBraun":"ButtonBraun_buttonBraun__2_GBL","link":"ButtonBraun_link__qFEGA","light":"ButtonBraun_light__2e_BD","dark":"ButtonBraun_dark__3daW6"};